import { useTranslation } from 'react-i18next';
import { scoreColor, fmtScore } from '@/utils/analytics';

interface DrillRow {
  id: string;
  name: string;
  sc: number;
  ev: number;
  om: number;
  children: Array<{ id: string; n: string; sc?: number; ev?: number; om?: number; children?: unknown[] }>;
}

interface OUDrillCardProps {
  ouScores: DrillRow[];
  ouDrillId: string | null;
  setOuDrillId: (id: string | null) => void;
}

function omitColor(pct: number) {
  if (pct >= 10) return '#ef4444';
  if (pct >= 5) return '#f59e0b';
  return '#059669';
}

export function OUDrillCard({ ouScores, ouDrillId, setOuDrillId }: OUDrillCardProps) {
  const { t } = useTranslation();

  let drillRows = ouScores;
  if (ouDrillId) {
    const ou = ouScores.find((o) => o.id === ouDrillId);
    if (ou) {
      drillRows = ou.children.map((bu) => ({
        id: bu.id,
        name: bu.n,
        sc: bu.sc ?? 0,
        ev: bu.ev ?? 0,
        om: bu.om ?? 0,
        children: (bu.children as DrillRow['children']) ?? [],
      }));
    }
  }

  return (
    <div className="au-card">
      <div className="au-card-header">
        <div>
          <div className="au-card-title">
            <i className="fas fa-building" aria-hidden="true" />
            {t('analytics.summary.scoreByOU')}
          </div>
          <div className="au-card-subtitle">{t('analytics.summary.scoreByOUSubtitle')}</div>
        </div>
        {ouDrillId && (
          <button
            className="au-bc-btn"
            onClick={() => setOuDrillId(null)}
            style={{ fontSize: 11 }}
          >
            <i className="fas fa-arrow-left" aria-hidden="true" /> {t('common.back')}
          </button>
        )}
      </div>
      <div className="au-ou-list">
        {drillRows.map((row) => (
          <div
            key={row.id}
            className="au-ou-row"
            onClick={() => !ouDrillId && row.children.length > 0 && setOuDrillId(row.id)}
            style={{ cursor: !ouDrillId && row.children.length > 0 ? 'pointer' : 'default' }}
          >
            <span className="au-ou-name">{row.name}</span>
            <div className="au-ou-bar">
              <div
                className="au-ou-bar-fill"
                style={{ width: `${(row.sc / 4) * 100}%`, background: scoreColor(row.sc) }}
              />
            </div>
            <span className="au-ou-score" style={{ color: scoreColor(row.sc) }}>
              {fmtScore(row.sc)}
            </span>
            <span className="au-ou-meta">{row.ev} eval</span>
            <span className="au-ou-omit" style={{ color: omitColor(row.om) }}>
              {row.om}% omit
            </span>
            {!ouDrillId && row.children.length > 0 && (
              <i className="fas fa-chevron-right au-ou-arrow" aria-hidden="true" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
